import React, { Component } from 'react';
import { Container, Row, Col, Table } from 'react-bootstrap';
import { MapContainer, Marker, TileLayer, Tooltip, AttributionControl } from 'react-leaflet';
import { POICommand } from '../commands/POICommand';
import { strings } from '../../resources/strings';
import { createTicketOfficeMarkerIcon } from '../leaflet/StopIcons';
import { loadWorkingHoursTranslations, translateWorkingHoursText } from '../../resources/workingHoursTranslations';

const BRAND_COLOR = '#102236';
const EXTERNAL_TICKET_OFFICE_COLOR = '#000000';

const ticketOfficeColor = (ticketOffice) => 11 === ticketOffice.type ? EXTERNAL_TICKET_OFFICE_COLOR : BRAND_COLOR;

const renderMultilineText = (text) => text.split(/\r\n|\r|\n/).map((line, i, lines) =>
    <React.Fragment key={i}>{line}{i < lines.length - 1 && <br />}</React.Fragment>
);

export class TicketOffice extends Component {
    constructor(props) {
        super(props);

        this.state = {
            commands: {
                poi: new POICommand()
            },
            nearTO: []
        }
    }

    componentDidMount() {
        this.getNearPOI();

        loadWorkingHoursTranslations().then(() => {
            this.forceUpdate();
        });
    }

    getNearPOI() {
        this.state.commands.poi.getNearPOI(window.defaultCoordinates.lat, window.defaultCoordinates.lng, 10000000, (r) => this.getNearPOISuccessCallback(r))
    }

    getNearPOISuccessCallback(result) {
        const { nearTO } = this.state;

        this.setState({
            nearTO: nearTO.concat(result.filter(r => nearTO.find(s => s.id === r.id) === undefined))
        });
    }

    render() {
        return (
            <Container fluid className="mb-5" >
                <Row>
                    <Col lg={12}>
                        <div className="mt-5">
                            <Table striped responsive className="ticket-office-table">
                                <thead>
                                    <tr>
                                        <th>{strings.town}</th>
                                        <th>{strings.address}</th>
                                        <th>{strings.schedule}</th>
                                        <th>{strings.ticketOfficeContact}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {0 === this.state.nearTO.length &&
                                        <tr>
                                            <td colSpan={4}>{strings.ticketOfficeListPending}</td>
                                        </tr>
                                    }
                                    {this.state.nearTO.map((ticketOffice) =>
                                        <tr key={`to-row-${ticketOffice.code}`}>
                                            <td><b style={{ color: ticketOfficeColor(ticketOffice) }}>{ticketOffice.name}</b></td>
                                            <td>{ticketOffice.description ? renderMultilineText(ticketOffice.description) : strings.ticketOfficeNoAddress}</td>
                                            <td>{ticketOffice.workingHours && 0 < ticketOffice.workingHours.length
                                                ? renderMultilineText(ticketOffice.workingHours.map(translateWorkingHoursText).join('\n'))
                                                : strings.ticketOfficeNoSchedule}</td>
                                            <td>{ticketOffice.contacts && 0 < ticketOffice.contacts.length
                                                ? renderMultilineText(ticketOffice.contacts.join('\n'))
                                                : strings.ticketOfficeNoContact}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>

                        <MapContainer className="map-container-ticket-office" center={[window.defaultCoordinates.lat, window.defaultCoordinates.lng]} zoom={10} scrollWheelZoom={true} attributionControl={false}>
                            <TileLayer
                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            <AttributionControl position="bottomright" prefix={false} />
                            {this.state.nearTO.map((ticketOffice) =>
                                <Marker
                                    key={`to-${ticketOffice.code}`}
                                    position={[ticketOffice.coordX, ticketOffice.coordY]}
                                    icon={createTicketOfficeMarkerIcon(ticketOfficeColor(ticketOffice))}>

                                    <Tooltip>
                                        <strong>{ticketOffice.name}</strong>
                                    </Tooltip>
                                </Marker>
                            )}
                        </MapContainer>
                    </Col>
                </Row>
            </Container>
        );
    }
}
